module.exports = __webpack_public_path__ + "static/img/Charlie-Dixon.fd8d4ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie-Dixon.jpg
// module id = rs47
// module chunks = 0